import React, { useState, useEffect } from 'react'
import './App.css'
import QueryBuilderLogo from './assets/query_builder_logo.png'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import SelectFeed from './components/SelectFeed'
import CustomFeed from './components/CustomFeed'
import SpotPrice from './components/SpotPrice'
import AWSSpotPrice from './components/AWSSpotPrice'
import DivaProtocolPolygon from './components/DivaProtocolPolygon'
import LeagueDAO from './components/LeagueDAO'
import LegacyRequest from './components/LegacyRequest'
import DataDecoder from './components/DataDecoder'

function App() {


  //useEffect for routing
  useEffect(() => {
    if (
      window.location.href.includes('/awsspotprice') ||
      window.location.href.includes('/custom') ||
      window.location.href.includes('/divaprotocolpolygon') ||
      window.location.href.includes('/datadecoder') ||
      window.location.href.includes('/leaguedao') ||
      window.location.href.includes('/legacyrequest') ||
      window.location.href.includes('/spotprice')
    ) {
     
    }
  }, [])



  return (
    <div className="App">
      <nav className="Nav">
        <a href="https://tellor.io/">
          <img src={QueryBuilderLogo} alt="Tellor Query Builder" />
        </a>
      </nav>
      <div className="BodyContainer">
        <header className="DictEntry">
          <h1 className="DictHeadword">query id</h1>
          <p className="DictMeta">
            <span className="DictPhonetic">/ˈkwɪə.ri aɪˈdiː/</span>
            <span className="DictPos">noun</span>
          </p>
        </header>
        <p className="BodyDescription">
          A 'query id' is the unique identifier unique identifier of a
          &lsquo;query type&rsquo; for data that&apos;s requested, reported, and
          retrieved by Tellor oracles. Use the tools below to generate a query
          id for your data, or decode an already submitted value.
          For a more detailed explanation of queries, see{' '}
          <a
            className="DescriptionLink"
            href="https://github.com/tellor-io/dataSpecs"
            target="_blank"
            rel="noopener noreferrer"
          >
            this &lsquo;data specs&rsquo; repo
          </a>
          .
        </p>
        
        <Router>
          <div className="HeroNavLinks">
            
            
          </div>
          <div className="HeroSection">
            <Routes>
            <Route path="/" element={<SpotPrice />} /> {/* Set the SpotPrice component as the default route */}
  <Route path="/spotprice" element={<SpotPrice />} />
              <Route path="/awsspotprice" element={<AWSSpotPrice />} />
              <Route path="/custom" element={<CustomFeed />} />
              <Route
                path="/divaprotocolpolygon"
                element={<DivaProtocolPolygon />}
              />
              <Route path="/leaguedao" element={<LeagueDAO />} />
              <Route path="/legacyrequest" element={<LegacyRequest />} />
              <Route path="/datadecoder" element={<DataDecoder />} />
            </Routes>
          </div>
        </Router>
    
      </div>
    </div>
  )
}

export default App
